export const baseCDNUrl = import.meta.env.VITE_MINIO_URL + '/s3static/static/';
export const downUrlName = import.meta.env.VITE_MINIO_URL + '/s3static/';
// cos下载模版地址
export const cosDownUrl = {
  1:
    downUrlName +
    'download_template/%E5%91%98%E5%B7%A5%E8%B4%A6%E5%8F%B7-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  3:
    downUrlName +
    'download_template/%E4%B8%BA%E5%91%98%E5%B7%A5%E5%88%86%E9%85%8D%E6%96%B0%E8%BE%96%E5%8C%BA-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  5:
    downUrlName +
    'download_template/%E8%AE%B2%E8%80%85-%E5%8C%BB%E9%99%A2%E5%AE%A2%E6%88%B7-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-no-allist.xlsx',
  6:
    downUrlName +
    'download_template/%E8%AE%B2%E8%80%85-%E5%8C%BB%E9%99%A2%E5%AE%A2%E6%88%B7-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-allist.xlsx',
  7:
    downUrlName +
    'download_template/%E8%BE%96%E5%8C%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  8:
    downUrlName +
    'download_template/%E6%A0%87%E7%AD%BE%E5%88%86%E7%B1%BB-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  9:
    downUrlName +
    'download_template/%E6%A0%87%E7%AD%BE-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  214:
    downUrlName +
    'download_template/%E7%9B%AE%E6%A0%87%E5%AE%A2%E6%88%B7%E8%AE%A4%E8%AF%81-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  14:
    downUrlName +
    'download_template/%E5%A2%9E%E5%8A%A0%E7%A7%AF%E5%88%86%E6%A8%A1%E7%89%88%20.xlsx',
  16:
    downUrlName +
    'download_template/%E6%B6%88%E8%80%97%E7%A7%AF%E5%88%86%E6%A8%A1%E7%89%88.xlsx',
  232:
    downUrlName +
    'download_template/%E8%BE%96%E5%8C%BA-%E4%BA%A7%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  12:
    downUrlName +
    'download_template/agency/%E6%9C%8D%E5%8A%A1%E5%95%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  13:
    downUrlName +
    'download_template/20250812/%E6%9C%8D%E5%8A%A1%E5%95%86%E4%BB%BB%E5%8A%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  // TODO 'download_template/%E6%9C%8D%E5%8A%A1%E5%95%86%E4%BB%BB%E5%8A%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  /* TODO: 'download_template/v2/%E6%9C%8D%E5%8A%A1%E5%95%86%E4%BB%BB%E5%8A%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx' */
  18: downUrlName + 'download_template/成本中心-导入模板.xlsx',
  19:
    downUrlName +
    'download_template/%E6%88%90%E6%9C%AC%E4%B8%AD%E5%BF%83-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-allist.xlsx',
  20:
    downUrlName +
    'download_template/%E5%8C%BB%E9%99%A2%E6%BD%9C%E5%8A%9B%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  24:
    downUrlName +
    'download_template/%E5%88%AB%E5%90%8D%E5%BA%93%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  28:
    downUrlName +
    'download_template/%E6%8C%87%E6%A0%87%E5%B2%97%E4%BD%8D%E5%8C%B9%E9%85%8D-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  30:
    downUrlName +
    'download_template/%E5%8C%BB%E9%99%A2%E4%BA%A7%E5%93%81%E6%8C%87%E6%A0%87-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  27:
    downUrlName +
    'download_template/%E7%9B%AE%E6%A0%87%E5%8C%BB%E7%94%9F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  403:
    downUrlName +
    'download_template/%E6%95%8F%E6%84%9F%E8%AF%8D-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  39:
    downUrlName +
    'download_template/%E9%9D%9E%E9%94%80%E5%94%AE%E8%BE%96%E5%8C%BA%E5%85%B3%E7%B3%BB%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  60:
    downUrlName +
    'download_template/%E8%8D%AF%E5%BA%97-%E5%88%AB%E5%90%8D%E5%BA%93%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  61:
    downUrlName +
    'download_template/%E7%BB%8F%E9%94%80%E5%95%86-%E5%88%AB%E5%90%8D%E5%BA%93%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  62:
    downUrlName +
    'download_template/%E5%8C%BB%E9%99%A2-%E5%88%AB%E5%90%8D%E5%BA%93%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  51:
    downUrlName +
    'download_template/agency/%E6%9C%8D%E5%8A%A1%E5%95%86%E4%BB%BB%E5%8A%A1%EF%BC%88%E8%B0%83%E7%A0%94%E9%97%AE%E5%8D%B7-%E6%99%AE%E9%80%9A%E8%B0%83%E7%A0%94%EF%BC%89-%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  70:
    downUrlName +
    '/download_template/v2/%E5%8C%BA%E5%8E%BF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  52:
    downUrlName +
    'download_template/%E9%9D%9E%E9%94%80%E7%9B%AE%E6%A0%87%E5%8C%BB%E7%94%9F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', // 非销目标医生
  1106:
    downUrlName +
    'download_template/v2/%E7%89%B9%E6%AE%8A%E5%A5%96%E5%8A%B1%E5%92%8C%E7%BD%9A%E6%89%A3%E5%AF%BC%E5%85%A52025_12_15.xlsx' // 特殊奖励和罚扣
};

export const integralBizType = [
  14, 15, 16, 17, 251, 70, 561, 72, 73, 74, 562, 563, 1113
]; // 积分关类型

export const indicatorBizType = [28, 29, 30, 37, 38, 40, 41, 42, 43,1105,1104]; //指标类型
// 导入中心2.0
// 客户-v6
export const client = [
  {
    title: '客户导入',
    needFilter: true, //需要根据tab配置过滤掉才定义true
    // explain:
    //   '通过新增模板批量导入新客户，通过覆盖模板批量修改已有客户的其他信息',
    child: [
      {
        name: '医院客户',
        downloadType: 'alone',
        type: 201,
        loading: false,
        id: 'HOSPITAL'
      },
      {
        name: '经销商客户',
        downloadType: 'alone',
        type: 216,
        loading: false,
        id: 'DEALER'
      },
      {
        name: '主管单位客户',
        downloadType: 'alone',
        type: 217,
        loading: false,
        id: 'COMPETENT_AUTHORITY'
      },
      {
        name: '药店客户',
        downloadType: 'alone',
        type: 301,
        loading: false,
        id: 'PHARMACY'
      }
    ]
  },
  {
    title: '机构导入',
    needFilter: true, //需要根据tab配置过滤掉才定义true
    // explain:
    // '通过新增模板批量导入新机构，通过覆盖模板批量修改已有机构的其他信息',
    child: [
      {
        name: '医院',
        downloadType: 'alone',
        type: 204,
        loading: false,
        id: 'HOSPITAL'
      },
      {
        name: '经销商',
        downloadType: 'alone',
        type: 211,
        loading: false,
        id: 'DEALER'
      },
      {
        name: '主管单位',
        downloadType: 'alone',
        type: 212,
        loading: false,
        id: 'COMPETENT_AUTHORITY'
      },
      {
        name: '药店',
        downloadType: 'alone',
        type: 300,
        loading: false,
        id: 'PHARMACY'
      }
    ]
  }
];
//客户-v7
export const clientV7 = [];
// 辖区-v6
export const popedom = [
  {
    title: '辖区导入',
    child: [
      {
        name: '辖区',
        explain: '仅支持批量新增辖区',
        downloadType: 'alone',
        type: 7,
        loading: false
      }
    ]
  },
  {
    title: '辖区-机构关联导入',
    needFilter: true, //需要根据tab配置过滤掉才定义true
    child: [
      {
        name: '辖区-医院',
        downloadType: 'alone',
        type: 213,
        loading: false,
        id: 'HOSPITAL'
      },
      {
        name: '辖区-经销商',
        downloadType: 'alone',
        type: 220,
        loading: false,
        id: 'DEALER'
      },
      {
        name: '辖区-主管单位',
        downloadType: 'alone',
        type: 221,
        loading: false,
        id: 'COMPETENT_AUTHORITY'
      },
      {
        name: '辖区-药店',
        downloadType: 'alone',
        type: 226,
        loading: false,
        id: 'PHARMACY'
      }
    ]
  }
];
//辖区-v7
export const popedomV7 = [];
// 产品-v6
export const product = [
  {
    title: '机构-产品关联导入',
    needFilter: true, //需要根据tab配置过滤掉才定义true
    child: [
      {
        name: '医院-产品',
        downloadType: 'alone',
        type: 215,
        loading: false,
        id: 'HOSPITAL'
      },
      {
        name: '经销商-产品',
        downloadType: 'alone',
        type: 218,
        loading: false,
        id: 'DEALER'
      },
      {
        name: '主管单位-产品',
        downloadType: 'alone',
        type: 219,
        loading: false,
        id: 'COMPETENT_AUTHORITY'
      },
      {
        name: '药店-产品',
        downloadType: 'alone',
        type: 228,
        loading: false,
        id: 'PHARMACY'
      }
    ]
  },
  {
    title: '客户-产品关联导入',
    needFilter: true, //需要根据tab配置过滤掉才定义true
    child: [
      {
        name: '医院客户-产品',
        downloadType: 'alone',
        type: 206,
        loading: false,
        id: 'HOSPITAL'
      },
      {
        name: '经销商客户-产品',
        downloadType: 'alone',
        type: 224,
        loading: false,
        id: 'DEALER'
      },
      {
        name: '主管单位客户-产品',
        downloadType: 'alone',
        type: 225,
        loading: false,
        id: 'COMPETENT_AUTHORITY'
      }
    ]
  },
  {
    title: '辖区-产品关联导入',
    child: [
      {
        name: '辖区-产品',
        downloadType: 'alone',
        type: 232,
        loading: false
      }
    ]
  }
];
//产品-v7
export const productV7 = [];
// 账号-v6
export const account = [
  {
    title: '帐号导入',
    child: [
      {
        name: '员工帐号',
        downloadType: 'alone',
        type: 1,
        loading: false
      }
    ]
  },
  {
    title: '帐号-辖区导入',
    child: [
      {
        name: '为员工分配新辖区',
        explain:
          '原有辖区的员工，从原有辖区移动到新辖区；没有辖区的员工直接分配到新辖区',
        downloadType: 'alone',
        type: 3,
        loading: false
      }
    ]
  },
  {
    title: '员工-客户数据导入',
    needFilter: true, //需要根据tab配置过滤掉才定义true
    child: [
      {
        name: '员工-医院客户分配关系',
        downloadType: 'alone',
        type: 208,
        loading: false,
        id: 'HOSPITAL'
      },
      {
        name: '员工-经销商客户分配关系',
        downloadType: 'alone',
        type: 222,
        loading: false,
        id: 'DEALER'
      },
      {
        name: '员工-主管单位客户分配关系',
        downloadType: 'alone',
        type: 223,
        loading: false,
        id: 'COMPETENT_AUTHORITY'
      },
      {
        name: '员工-药店客户分配关系',
        downloadType: 'alone',
        type: 227,
        loading: false,
        id: 'PHARMACY'
      }
    ]
  }
];
// 账号-v7
export const accountV7 = [
  {
    title: '帐号导入',
    child: [
      {
        name: '员工帐号',
        downloadType: 'alone',
        type: 1,
        loading: false
      }
    ]
  }
];

// 账号-湖岸新功能-V7
export const accountOmsV7 = [
  {
    title: '帐号导入',
    child: [
      {
        name: '内部账号',
        downloadType: 'alone',
        type: 1005,
        loading: false
      },
      {
        name: '服务商帐号',
        downloadType: 'alone',
        type: 1004,
        loading: false
      },
      {
        name: '账号角色区域',
        downloadType: 'alone',
        type: 1003,
        loading: false
      }
    ]
  }
];

// BI-v7
export const BIV7 = [
  {
    title: '排名表导入',
    child: [
      {
        name: '排名表',
        disableDownLoad: true,
        type: 80,
        loading: false
      }
    ]
  },
  {
    title: '医院状态导入',
    child: [
      {
        name: '医院状态',
        type: 88,
        loading: false
      }
    ]
  },
  {
    title: '医生状态导入',
    child: [
      {
        name: '医生状态',
        type: 87,
        loading: false
      }
    ]
  },
  {
    title: 'Data mapping表导入',
    child: [
      {
        name: 'Data mapping表',
        type: 86,
        loading: false
      }
    ]
  }
];
// 会议-v6
export const meeting = [
  {
    title: '讲者导入',
    child: [
      {
        name: '讲者-医院客户',
        explain: '根据系统客户ID更新/新增导入下载模版上传数据',
        downloadType: 'alone',
        type: 5,
        loading: false
      }
    ]
  }
];
// 会议-v7
export const meetingV7 = [];
// 服务商-v6
export const service = [
  {
    title: '服务商导入',
    child: [
      {
        name: '服务商',
        explain: '附件无法导入，可导入服务商后在服务商管理中补充附件材料',
        downloadType: 'alone',
        type: 12,
        loading: false
      }
    ]
  },
  {
    title: '服务商任务导入',
    child: [
      {
        name: '服务商任务',
        explain: '批量下发服务任务到服务商',
        downloadType: 'alone',
        type: 13,
        loading: false
      },
      {
        name: '服务商任务-调研问卷普通调研',
        explain: '批量下发服务任务到服务商',
        downloadType: 'alone',
        type: 51,
        loading: false
      }
    ]
  }
];

// 服务商-v7
export const serviceV7 = [
  {
    title: '服务商导入',
    child: [
      {
        name: '服务商',
        explain: '附件无法导入，可导入服务商后在服务商管理中补充附件材料',
        downloadType: 'alone',
        type: 12,
        loading: false
      }
    ]
  },
  {
    title: '服务商任务导入',
    child: [
      {
        name: '服务商任务',
        explain: '批量下发服务任务到服务商',
        downloadType: 'alone',
        type: 13,
        loading: false
      },
      {
        name: '服务商任务-调研问卷普通调研',
        explain: '批量下发服务任务到服务商',
        downloadType: 'alone',
        type: 51,
        loading: false
      }
    ]
  }
];

// 拜访-v6（旧版本）
export const visit = [
  {
    title: '拜访数据导入',
    child: [
      {
        name: '拜访数据导入',
        explain: '根据最新的模板字段导入数据',
        downloadType: 'alone',
        type: 1001,
        loading: false
      }
    ]
  }
];

// 拜访-v7（新版本）
export const visitV7 = [
  {
    title: '拜访数据导入',
    child: [
      {
        name: '拜访数据导入',
        explain: '根据最新的模板字段导入数据',
        downloadType: 'alone',
        type: 1001,
        loading: false
      }
    ]
  }
];

// 其他-v6
export const other = [
  {
    title: '标签导入',
    child: [
      {
        name: '标签分类',
        explain: '批量新增标签分类，无法修改现有标签分类下载模板上传数据',
        downloadType: 'alone',
        type: 8,
        loading: false
      },
      {
        name: '标签',
        explain: '批量新增标签，无法修改现有标签',
        downloadType: 'alone',
        type: 9,
        loading: false
      }
    ]
  },
  {
    title: '客户认证信息导入',
    child: [
      {
        name: '目标客户认证',
        downloadType: 'alone',
        type: 214,
        loading: false
      }
    ]
  },
  {
    title: '积分导入',
    child: [
      {
        name: '用户积分',
        downloadType: 'all',
        downloadDesc: {
          ADD: '增加积分模板',
          COVER: '消耗积分模板'
        },
        downloadButton: [
          {
            name: '批量消耗积分',
            buttonType: 'danger',
            type: 17,
            loading: false
          },
          {
            name: '批量增加积分',
            type: 15,
            loading: false
          }
        ],
        typeMore: {
          ADD: 14,
          COVER: 16
        },
        loading: false
      },
      {
        name: '员工积分',
        downloadType: 'all',
        downloadDesc: {
          ADD: '增加积分模板',
          COVER: '消耗积分模板'
        },
        downloadButton: [
          {
            name: '批量消耗积分',
            buttonType: 'danger',
            type: 16,
            loading: false
          },
          {
            name: '批量增加积分',
            type: 14,
            loading: false
          }
        ],
        typeMore: {
          ADD: 14,
          COVER: 16
        },
        loading: false
      }
    ]
  },
  {
    title: '敏感词导入',
    child: [
      {
        name: '敏感词',
        downloadType: 'alone',
        type: 403,
        loading: false
      }
    ]
  }
];
// 其他-v7
export const otherV7 = [
  {
    title: '标签导入',
    child: [
      {
        name: '标签分类',
        explain: '批量新增标签分类，无法修改现有标签分类下载模板上传数据',
        downloadType: 'alone',
        type: 8,
        loading: false
      },
      {
        name: '标签',
        explain: '批量新增标签，无法修改现有标签',
        downloadType: 'alone',
        type: 9,
        loading: false
      }
    ]
  },
  {
    title: '积分导入',
    child: [
      {
        name: '用户积分',
        downloadType: 'all',
        downloadDesc: {
          ADD: '增加积分模板',
          COVER: '消耗积分模板'
        },
        downloadButton: [
          {
            name: '批量消耗积分',
            buttonType: 'danger',
            type: 17,
            loading: false
          },
          {
            name: '批量增加积分',
            type: 15,
            loading: false
          }
        ],
        typeMore: {
          ADD: 14,
          COVER: 16
        },
        loading: false
      },
      {
        name: '员工积分',
        downloadType: 'all',
        downloadDesc: {
          ADD: '增加积分模板',
          COVER: '消耗积分模板'
        },
        downloadButton: [
          {
            name: '批量消耗积分',
            buttonType: 'danger',
            type: 16,
            loading: false
          },
          {
            name: '批量增加积分',
            type: 14,
            loading: false
          }
        ],
        typeMore: {
          ADD: 14,
          COVER: 16
        },
        loading: false
      }
    ]
  },
  {
    title: '敏感词导入',
    child: [
      {
        name: '敏感词',
        downloadType: 'alone',
        type: 403,
        loading: false
      }
    ]
  }
];
